import * as React                   from "react"
import PropTypes                    from "prop-types"
import _                            from "lodash"
import SynthesisComponent           from "./synthesis-component"
import { CHART_SECTIONS }           from "./synthesis-component"
import LocalAuthority               from "../../../model/local-authority"
import Observation                  from "../../../model/observation"
import LocalAuthorityChapterAccount from "../../../model/local-authority-chapter-account"
import { ColorsHelper }             from "../../../util/colors"

/** @type {number} */           const INITIAL_COLOR_OFFSET      = 30;
/** @type {LabeledChapter[]} */ const EXPENSE_LABELED_CHAPTERS  = [];
/** @type {LabeledChapter[]} */ const RECEIPTS_LABELED_CHAPTERS = [];

export default class SynthesisContainer extends React.Component {

	constructor(props) {
		super(props)

		this._setLabels(props);
		this._updateProperties(props)

		const tableData = this._getTableData(props, this.totalExpense, this.totalReceipts, this.expensePerInhabitant, this.receiptsPerInhabitant)

		this.state = {
			displayCharts         : false,
			modalTitles           : {},
			perInhabitantChartData: {},
			pieChartData          : {},
			totalChartData        : {},
			tableData
		}
	}

	componentDidMount() {
		if(!this.props.localAuthority) return;

		this._setLabels(this.props);
		this._updateProperties(this.props)

		const displayCharts          = this.state.displayCharts
		const lastYear               = _.last(this.props.years)
		const modalTitles            = this._getModalTitles(displayCharts, lastYear)
		const perInhabitantChartData = this._getPerInhabitantChartData(displayCharts, this.expensePerInhabitant, this.receiptsPerInhabitant, this.props.years)
		const pieChartData           = this._getPieChartData(displayCharts, this.totalExpense, this.totalReceipts, lastYear)
		const tableData              = this._getTableData(this.props, this.totalExpense, this.totalReceipts, this.expensePerInhabitant, this.receiptsPerInhabitant)
		const totalChartData         = this._getTotalChartData(displayCharts, this.totalExpense, this.totalReceipts, this.props.years)

		this.setState({
			modalTitles,
			perInhabitantChartData,
			pieChartData,
			tableData,
			totalChartData
		})
	}

	componentWillReceiveProps(nextProps) {
		if(!nextProps.localAuthority) return;

		this._setLabels(nextProps);
		this._updateProperties(nextProps)

		const displayCharts          = this.state.displayCharts
		const lastYear               = _.last(nextProps.years)
		const modalTitles            = this._getModalTitles(displayCharts, lastYear)
		const perInhabitantChartData = this._getPerInhabitantChartData(displayCharts, this.expensePerInhabitant, this.receiptsPerInhabitant, nextProps.years)
		const pieChartData           = this._getPieChartData(displayCharts, this.totalExpense, this.totalReceipts, lastYear)
		const tableData              = this._getTableData(nextProps, this.totalExpense, this.totalReceipts, this.expensePerInhabitant, this.receiptsPerInhabitant)
		const totalChartData         = this._getTotalChartData(displayCharts, this.totalExpense, this.totalReceipts, nextProps.years)

		this.setState({
			modalTitles,
			perInhabitantChartData,
			pieChartData,
			tableData,
			totalChartData
		})
	}

	render() {
		if (!this.props.localAuthority) return null;

		return (
			<SynthesisComponent
			displayCharts          = {this.state.displayCharts}
			loading                = {this.props.loading}
			id                     = {this.props.id}
			modalTitles            = {this.state.modalTitles}
			perInhabitantChartData = {this.state.perInhabitantChartData}
			pieChartData           = {this.state.pieChartData}
			onClickChartModalTab   = {this._handleChartModalClick}
			onClickHideCharts      = {this._handleClickHideCharts}
			onClickShowCharts      = {this._handleClickShowCharts}
			slug                   = {this.props.localAuthority.slug}
			tableData              = {this.state.tableData}
			totalChartData         = {this.state.totalChartData}
			years                  = {this.props.years} />
		)
	}

	_updateProperties = (props) => {
		if (props.localAuthority) {

			this.totalExpense             = this._getInitialTotalExpense();
			this.totalReceipts            = this._getInitialTotalReceipts();
			this.expensePerInhabitant     = this._getInitialExpensePerInhabitant();
			this.receiptsPerInhabitant    = this._getInitialReceiptsPerInhabitant();
			let listOperationOrderReceipt = this._getOrderOperation(["021", "023", "040", "041", "042", "043"], props.localAuthority.accounts, props.localAuthority.observations, true, true, props.years);
			let listOperationOrderExpense = this._getOrderOperation(["021", "023", "040", "041", "042", "043"], props.localAuthority.accounts,props.localAuthority.observations, true, false, props.years);
			let orderOperationReceipt     = {};
			let orderOperationExpense     = {};

			this._initializeValues(orderOperationExpense, props.years);
			this._initializeValues(orderOperationReceipt, props.years);

			listOperationOrderReceipt.forEach(row => {
				props.years.forEach(y => {
					orderOperationReceipt[y.toString()] += row[y.toString()]
				})
			})
			listOperationOrderExpense.forEach(row => {
				props.years.forEach(y => {
					orderOperationExpense[y.toString()] += row[y.toString()]
				})
			})

			_.forEach(props.years, (/** @type {Number} */ y) => {
				const yearKey = y.toString()
				// initialisation des valeurs à 0
				_.forEach(_.concat(this.totalReceipts, this.totalExpense, ), row => {
					row[yearKey] = 0
				})

				_.forEach(_.concat(this.receiptsPerInhabitant, this.expensePerInhabitant), row => {
					row[yearKey] = props.inhabitants[yearKey] ? 0 : null
				})

				// pour chaque constat de la collectivité locale
				_.forEach(props.localAuthority.observations, (/** @type {Observation} */ o) => {
					// si l'année ne correspond pas
					// ou si ce n'est pas un fonctionnement,
					// interruption de la boucle
					if (y !== o.year || !o.account.operation) return

					// récupération de la relation localAuthorityChapterAccount du constat
					/** @type {LocalAuthorityChapterAccount} */ const indexedAccount = _.find(
						props.localAuthority.accounts,
						(/** @type {LocalAuthorityChapterAccount} */ lca) => (
							o.account.id === lca.account.id
						)
					)

					if(!indexedAccount) return

					const chapter = indexedAccount.chapter
					const account = indexedAccount.account

					if (o.receipts) { // si le constat est une recette
						// recette totales
						this.totalReceipts[0][yearKey] += o.amount

						// si le numéro du compte du constat ne commence pas par une des exceptions
						if (chapter) {
							const indexChapter = _.findIndex(this.totalReceipts, ch => ch.chapter && ch.chapter.number === chapter.number)
							if(indexChapter > 0) this.totalReceipts[indexChapter][yearKey] += o.amount;
						}
						if(chapter === null) {
							const indexNoneChapter = _.findIndex(this.totalReceipts, ch => ch.chapter === null)
							this.totalReceipts[indexNoneChapter][yearKey] += o.amount
						}

					} else { // sinon c'est une dépense
						// dépenses totales
						this.totalExpense[0][yearKey] += o.amount

						// si le numéro du compte du constat ne commence pas par une des exceptions
						if (chapter) {
							const indexChapter = _.findIndex(this.totalExpense, ch => ch.chapter && ch.chapter.number === chapter.number)
							if(indexChapter > 0) this.totalExpense[indexChapter][yearKey] += o.amount;
						}
						if(chapter === null) {
							const indexNoneChapter = _.findIndex(this.totalExpense, ch => ch.chapter === null)
							this.totalExpense[indexNoneChapter][yearKey] += o.amount
						}
					}
				})

				for (let i = 1; i < this.totalReceipts.length; i++)
					this.totalReceipts[1][yearKey] += this.totalReceipts[i][yearKey]

				for (let i = 2; i < this.totalExpense.length; i++)
					this.totalExpense[1][yearKey] += this.totalExpense[i][yearKey]

				this.totalReceipts[1][yearKey] -= orderOperationReceipt[yearKey]
				this.totalExpense[1][yearKey] -= orderOperationExpense[yearKey]

				if (props.inhabitants[yearKey]) {
					for (let i = 0; i < this.totalReceipts.length; i++)
						this.receiptsPerInhabitant[i][yearKey] = this.totalReceipts[i][yearKey] / props.inhabitants[yearKey]

					for (let i = 0; i < this.totalExpense.length; i++)
						this.expensePerInhabitant[i][yearKey] = this.totalExpense[i][yearKey] / props.inhabitants[yearKey]
				}
			})
		}
	}

	_initializeValues = (data, years) => {
		years.forEach(y => {
			data[y.toString()] = 0
		})
	}

	_getInitialExpensePerInhabitant = () => {
		return _.concat([
			{ label: "Dépense fonctionnement par habitant", isCurrency: true, isTitle: true },
			{ label: "Dont fonctionnement réel",            isCurrency: true }
		], _.map(EXPENSE_LABELED_CHAPTERS, l => ({ label: l.label, isCurrency: true, isDetail: true })))
	}

	_getInitialReceiptsPerInhabitant = () => {
		return _.concat([
			{ label: "Recette fonctionnement par habitant", isCurrency: true, isTitle: true },
			{ label: "Dont fonctionnement réel" ,            isCurrency: true }
		], _.map(RECEIPTS_LABELED_CHAPTERS, l => ({ label: l.label, isCurrency: true, isDetail: true })))
	}

	_getModalTitles = (displayCharts, lastYear) => {
		return displayCharts === CHART_SECTIONS.EXPENSE
			?	{
					perInhabitantChart: "Dépenses réelles de fonctionnement par habitant",
					pieChart          : `Dépenses réelles en ${lastYear}`,
					totalChart        : "Dépenses réelles de fonctionnement"
				}
			: 	{
					perInhabitantChart: "Recettes réelles de fonctionnement par habitant",
					pieChart          : `Recettes réelles en ${lastYear}`,
					totalChart        : "Recettes réelles de fonctionnement"
				}
	}

	_getOrderOperation = (
		/** @type {String[]} */      listOrderOperation,
		/** @type {Account[]} */     accounts,
		/** @type {Observation[]} */ observations,
		/** @type {Boolean} */       operation,
		/** @type {Boolean} */       receipts,
		/** @type {Number[]} */      years
	) => {
		let tab = [];
		let obj = {};
		let listChapter = [];

		let filteredArranged = accounts
		.filter(laca => (
			laca.account.operation === operation
			&& laca.account.receipts === receipts
			&& laca.chapter
			&& laca.chapter.number.startsWith("0")
		));

		// On ajoute chaque chapitre qu'une seule fois à une liste -> listChapter

		listOrderOperation.forEach(oo => {
			filteredArranged.forEach(fa => {
				if(fa.chapter.number === oo && !_.some(listChapter, ch => ch.chapter.number === oo)) listChapter.push({chapter: fa.chapter, account: fa.account});
			})
		});

		const data = listChapter.map(info => {
			const row  = { info };
			// Pour chaque année on filtre les nouvelles observations par rapport à y, receipts, operation
			years.forEach(y => {
				const obs = _.filter(observations, (/** @type {Observation}*/ o) => {
					const obsIndexedAccount = _.find(filteredArranged, c => o.account.id === c.account.id);
					const isSameYear = o.year === y;
					const isSameReceipts = o.account.receipts === receipts;
					const isSameOperation = o.account.operation === operation;
					return obsIndexedAccount && obsIndexedAccount.chapter && obsIndexedAccount.chapter.id === info.chapter.id  && isSameYear && isSameReceipts && isSameOperation;
				})
				row[y] = _.round(_.sumBy(obs, o => o.amount), 2);
			})

			return row
		});

		return data;
	}

	_getPerInhabitantChartData = (displayCharts, expensePerInhabitant, receiptsPerInhabitant, years) => {
		let colors                   = ColorsHelper.getEquidistantPastelColors(RECEIPTS_LABELED_CHAPTERS.length, INITIAL_COLOR_OFFSET)
		const perInhabitantChartData = {
			labels  : years,
			datasets: RECEIPTS_LABELED_CHAPTERS.map((l, i) => ({
				backgroundColor: colors[i],
				data           : years.map(year => receiptsPerInhabitant[i + 2][year]),
				label          : l.label
			}))
		}

		if (displayCharts === CHART_SECTIONS.EXPENSE) {
			colors                          = ColorsHelper.getEquidistantPastelColors(EXPENSE_LABELED_CHAPTERS.length, INITIAL_COLOR_OFFSET)
			perInhabitantChartData.datasets = EXPENSE_LABELED_CHAPTERS.map((l, i) => ({
				backgroundColor: colors[i],
				data           : years.map(year => expensePerInhabitant[i + 2][year]),
				label          : l.label
			}))
		}

		return perInhabitantChartData
	}

	_getPieChartData = (displayCharts, totalExpense, totalReceipts, lastYear) => {
		const pieChartData = {
			labels  : RECEIPTS_LABELED_CHAPTERS.map(l => l.label),
			datasets: [{
				backgroundColor: ColorsHelper.getEquidistantPastelColors(RECEIPTS_LABELED_CHAPTERS.length, INITIAL_COLOR_OFFSET),
				data           : RECEIPTS_LABELED_CHAPTERS.map((l, i) => totalReceipts[i + 2][lastYear])
			}]
		}

		if (displayCharts === CHART_SECTIONS.EXPENSE) {
			pieChartData.labels                      = EXPENSE_LABELED_CHAPTERS.map(l => l.label)
			pieChartData.datasets[0].backgroundColor = ColorsHelper.getEquidistantPastelColors(EXPENSE_LABELED_CHAPTERS.length, INITIAL_COLOR_OFFSET)
			pieChartData.datasets[0].data            = EXPENSE_LABELED_CHAPTERS.map((l, i) => totalExpense[i + 2][lastYear])
		}

		return pieChartData
	}

	_getInitialTotalExpense = () => {
		return _.concat([
			{ label: "Total dépense fonctionnement",  isCurrency: true, isTitle: true },
			{ label: "Dont fonctionnement réel",      isCurrency: true }
		], EXPENSE_LABELED_CHAPTERS.map(l => ({ ...l, isCurrency: true, isDetail: true })))
	}

	_getInitialTotalReceipts = () => {
		return _.concat([
			{ label: "Total recette fonctionnement",  isCurrency: true, isTitle: true },
			{ label: "Dont fonctionnement réel",      isCurrency: true }
		], RECEIPTS_LABELED_CHAPTERS.map(l => ({ ...l, isCurrency: true, isDetail: true })))
	}

	_getTableData = (props, totalExpense, totalReceipts, expensePerInhabitant, receiptsPerInhabitant) => {
		return _.concat(
			totalReceipts,
			null,
			totalExpense,
			null,
			[{ label: "Habitants", isTitle: true, ...props.inhabitants }],
			null,
			receiptsPerInhabitant,
			null,
			expensePerInhabitant
		)
	}

	_getTotalChartData = (displayCharts, totalExpense, totalReceipts, years) => {
		let colors           = ColorsHelper.getEquidistantPastelColors(RECEIPTS_LABELED_CHAPTERS.length, INITIAL_COLOR_OFFSET)
		const totalChartData = {
			labels  : years,
			datasets: RECEIPTS_LABELED_CHAPTERS.map((l, i) => ({
				backgroundColor: colors[i],
				data           : years.map(year => totalReceipts[i + 2][year]),
				label          : l.label
			}))
		}

		if (displayCharts === CHART_SECTIONS.EXPENSE) {
			colors                  = ColorsHelper.getEquidistantPastelColors(EXPENSE_LABELED_CHAPTERS.length, INITIAL_COLOR_OFFSET)
			totalChartData.datasets = EXPENSE_LABELED_CHAPTERS.map((l, i) => ({
				backgroundColor: colors[i],
				data           : years.map(year => totalExpense[i + 2][year]),
				label          : l.label
			}))
		}

		return totalChartData
	}

	_handleChartModalClick = (
		/** @type {String} */               displayCharts,
		/** @type {React.SyntheticEvent<Element>} */ event
	) => {
		const lastYear               = _.last(this.props.years)
		const modalTitles            = this._getModalTitles(displayCharts, lastYear)
		const perInhabitantChartData = this._getPerInhabitantChartData(displayCharts, this.expensePerInhabitant, this.receiptsPerInhabitant, this.props.years)
		const pieChartData           = this._getPieChartData(displayCharts, this.totalExpense, this.totalReceipts, lastYear)
		const totalChartData         = this._getTotalChartData(displayCharts, this.totalExpense, this.totalReceipts, this.props.years)
		this.setState({
			displayCharts,
			modalTitles,
			perInhabitantChartData,
			pieChartData,
			totalChartData
		})
	}

	_handleClickShowCharts = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		const displayCharts          = true
		const lastYear               = _.last(this.props.years)
		const modalTitles            = this._getModalTitles(displayCharts, lastYear)
		const perInhabitantChartData = this._getPerInhabitantChartData(displayCharts, this.expensePerInhabitant, this.receiptsPerInhabitant, this.props.years)
		const pieChartData           = this._getPieChartData(displayCharts, this.totalExpense, this.totalReceipts, lastYear)
		const totalChartData         = this._getTotalChartData(displayCharts, this.totalExpense, this.totalReceipts, this.props.years)
		this.setState({
			displayCharts,
			modalTitles,
			perInhabitantChartData,
			pieChartData,
			totalChartData
		})
	}

	_handleClickHideCharts = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		this.setState({ displayCharts: false })
	}

	_setLabels = (props) => {
		if(!props.localAuthority) return
		_.forEach(props.localAuthority.observations, (/** @type {Observation} */ o) => {

			if (!o.account.operation) return

			/** @type {LocalAuthorityChapterAccount} */ const indexedAccount = _.find(
				props.localAuthority.accounts,
				(/** @type {LocalAuthorityChapterAccount} */ lca) => (
					o.account.id === lca.account.id
				)
			)
			if(!indexedAccount) return
			const chapter = indexedAccount.chapter
			const account = indexedAccount.account
			if(chapter) {
				if(account.receipts && !_.some(RECEIPTS_LABELED_CHAPTERS, l => l.chapter && l.chapter.number === chapter.number)) {
					RECEIPTS_LABELED_CHAPTERS.push({ chapter, label: "Dont "+ chapter.label})
				}
				if(!account.receipts && !_.some(EXPENSE_LABELED_CHAPTERS, l => l.chapter && l.chapter.number === chapter.number)) {
					EXPENSE_LABELED_CHAPTERS.push({ chapter, label: "Dont "+ chapter.label})
				}
			}
		})
		if(!_.some(RECEIPTS_LABELED_CHAPTERS, ch => ch.chapter === null)) RECEIPTS_LABELED_CHAPTERS.push({chapter: null, label: "Dont Non chapitrés"});
		if(!_.some(EXPENSE_LABELED_CHAPTERS, ch => ch.chapter === null)) EXPENSE_LABELED_CHAPTERS.push({chapter: null, label: "Dont Non chapitrés"});
	}
}

/**
 * @typedef {object} LabeledChapter
 * @property {Chapter} chapter
 * @property {string}  label
 */


// WEBPACK FOOTER //
// ./src/component/ratios/synthesis/synthesis-container.js